import T from 'prop-types';
import styled from 'styled-components';
import { blackAlpha8, white, black16 } from '../../styles/colors';
import { NavigationColumn as LocalNavigationColumn } from '../NavigationColumn/NavigationColumn';
import { NavigationItem as LocalNavigationItem } from '../NavigationItem/NavigationItem';
import { LocalNavigationDropdownItem } from './LocalNavigationDropdownItem';
import { Container } from '../Container/Container';
import { jsx as _jsx } from "react/jsx-runtime";
const Nav = /*#__PURE__*/styled.nav.withConfig({
  displayName: "Nav",
  componentId: "sc-4mujgd-0"
})(["display:flex;width:100%;height:40px;background-color:", ";border-bottom:solid 1px ", ";box-shadow:0px 1px 2px ", ";"], white, black16, blackAlpha8);

const LocalNavigation = ({
  children
}) => /*#__PURE__*/_jsx(Nav, {
  children: /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(LocalNavigationColumn, {
      align: "left",
      children: children
    })
  })
});

LocalNavigation.propTypes = {
  children: T.node
};
export { LocalNavigation, LocalNavigationItem, LocalNavigationColumn, LocalNavigationDropdownItem };